export const GROUP_PREFIX = 'group-';
export const RESERVATION_PREFIX = 'reservation-';
